import { useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/icons/header-icons/user-icon.svg";
import {
  LOGIN_ROUTE,
  REGISTER,
  useAppSelector,
} from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";
import LoginSection from "./LoginSection";

const LoginButtons = () => {
  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);

  const handleSignupClick = () => {
    navigate(REGISTER);
  };
  const { langData } = useAppSelector((state) => state.cms);

  return (
    <div className="flex items-center gap-2">
      <img
        src={UserIcon}
        alt=""
        className="hidden h-3.5 w-3.5 opacity-90 md:block"
        aria-hidden
      />

      <LoginSection isHeader />

      <div className="flex items-center gap-1 md:hidden">
        {domainConfig?.b2cEnabled && (
          <HeaderButtonComponent
            onClick={handleSignupClick}
            buttonText={langData?.["sign_up"]}
            customCSS="rounded text-sm bg-button-gradient"
          />
        )}
        <HeaderButtonComponent
          leftIcon={{ src: UserIcon, alt: "user-icon" }}
          onClick={() => navigate(LOGIN_ROUTE)}
          buttonText={langData?.["login"]}
          customCSS="bg-custom-red-gradient text-white rounded"
        />
      </div>
    </div>
  );
};

export default LoginButtons;
